import React from "react";
import { Label, Input, Textarea } from "../ui";

type Step2Props = {
  name: string;
  description: string;
  onNameChange: (name: string) => void;
  onDescriptionChange: (description: string) => void;
};

export function Step2_Details({ name, description, onNameChange, onDescriptionChange }: Step2Props) {
  return (
    <div className="grid gap-3">
      <div className="space-y-1">
        <Label htmlFor="pool-name" requiredIndicator>
          Pool Name
        </Label>
        <Input id="pool-name" type="text" value={name} onChange={(event) => onNameChange(event.target.value)} required />
      </div>
      <div className="space-y-1">
        <Label htmlFor="pool-description">Description</Label>
        <Textarea
          id="pool-description"
          value={description}
          onChange={(event) => onDescriptionChange(event.target.value)}
          rows={2}
          placeholder="Optional details about scoring, entry rules, etc."
        />
      </div>
    </div>
  );
}
